// Mock data para El Muro Endler

export const bookInfo = {
  title: "EL MURO ENDLER",
  subtitle: "Cómo construir una defensa inquebrantable y conquistar el mundo",
  author: "Christiane Endler",
  tagline: "El gol más difícil de defender es el que te haces a ti mismo",
  price: 29990,
  currency: "CLP",
  priceUSD: 35,
  description: "Este libro no es la biografía de una portera. Es el manual de obra para que tú también levantes tu propio Muro Endler: esa defensa mental, emocional y profesional que nadie, ni siquiera la vida, pueda tumbar.",
  releaseDate: "2026-06-15",
  pages: 280,
  isbn: "978-956-XXXX-XX-X",
  publisher: "Editorial Champions",
  coverImage: "https://customer-assets.emergentagent.com/job_muro-endler/artifacts/j1s8g1xo_995595AF-CE50-4F84-8786-7BA89849BDA5.png"
};

export const chapters = [
  {
    id: 1,
    number: "Capítulo 1",
    title: "El primer ladrillo",
    subtitle: "De delantera a guardiana",
    summary: "Santiago de Chile, verano de 2006. Christiane tenía quince años y era delantera. Pero Marco Antonio Cornez vio algo diferente en ella. 'Con esa altura y esos reflejos... vas a ser la mejor arquera de Chile'. Ese día cambió todo. El primer ladrillo del muro se puso con un 'sí, puedo' susurrado en la oscuridad.",
    lesson: "No elijas el camino cómodo. Elige el que te obliga a crecer. Porque el primer ladrillo siempre duele. Pero es el que sostiene todo lo que viene después.",
    year: "2006",
    location: "Santiago, Chile"
  },
  {
    id: 2,
    number: "Capítulo 2",
    title: "Altura no es solo física",
    subtitle: "La base del muro",
    summary: "A los 20 años, Tiane medía 1,83m. En Colo-Colo, llegaba una hora antes que todas. Hacía gimnasio con pesas oxidadas. Grababa partidos con su propia cámara. No esperó a que el club lo hiciera. Ella levantó el estándar. La altura física la tenía. La altura mental la construyó ladrillo a ladrillo.",
    lesson: "Tu mayor ventaja no es lo que te dio Dios. Es lo que tú decides multiplicar cada mañana. Porque el muro más alto no se levanta con estatura. Se levanta con preparación.",
    year: "2011",
    location: "Santiago, Chile"
  },
  {
    id: 3,
    number: "Capítulo 3",
    title: "La grieta que casi lo derrumba",
    subtitle: "La lesión que lo hizo más fuerte",
    summary: "Copa América 2015. Rotura de menisco medial. 'Pensé seriamente en retirarme', confesaría años después. Volvió a Las Condes con muletas y el alma hecha pedazos. Pero su papá le dijo: 'El muro no se cae por una grieta. Se cae si dejas de poner cemento'. Seis meses después volvió más fuerte.",
    lesson: "El muro más inquebrantable no es el que nunca recibe golpes. Es el que se reconstruye mejor después de cada terremoto.",
    year: "2015",
    location: "Chile"
  },
  {
    id: 4,
    number: "Capítulo 4",
    title: "Construyendo en terreno hostil",
    subtitle: "Profesionalizar lo que nadie valoraba",
    summary: "Colo-Colo 2016. Las duchas echaban agua fría. No había gimnasio decente. Tiane no se quejó. Contrató una nutricionista con su plata. Grababa partidos para análisis táctico. Llegaba primera, se iba última. 'Si no hay muro, tú eres el primero que lo levanta', decía. Y lo levantó.",
    lesson: "No esperes que el entorno esté listo para ti. Tú lo preparas para que esté listo para las que vienen detrás. Porque el verdadero liderazgo no es arrastrar. Es subir el estándar para que todos tengan que crecer contigo.",
    year: "2016",
    location: "Santiago, Chile"
  },
  {
    id: 5,
    number: "Capítulo 5",
    title: "El cemento del silencio",
    subtitle: "Liderazgo sin necesidad de gritar",
    summary: "Mundial 2019 en Francia. Tiane era capitana pero nunca gritaba. Contra Suecia, cuando el equipo estaba nervioso, solo dijo bajito: 'Estamos aquí. Yo las cubro'. Y todas respiraron. Su liderazgo no tenía volumen. Tenía peso. Las compañeras la seguían porque la veían entrenar, sacrificarse, ser la primera.",
    lesson: "El cemento más fuerte del muro no es el que se ve. Es el que une todo en silencio. Porque el liderazgo verdadero no arrastra. Inspira. Y la mejor inspiración es el ejemplo que nadie puede ignorar.",
    year: "2019",
    location: "Montpellier, Francia"
  },
  {
    id: 6,
    number: "Capítulo 6",
    title: "El partido que probó todo el muro",
    subtitle: "La Champions que nadie esperaba",
    summary: "Turín, 21 de mayo de 2022. Lyon vs Barcelona. Final de Champions. Esa mañana había muerto Marco Cornez, el hombre que la descubrió. Tiane lloró en su habitación. Pero salió al campo y paró todo. Lyon ganó 3-1. Ella fue MVP. 'Esto es para ti, profe'. Primera chilena campeona de Europa. El muro aguantó la prueba más dura.",
    lesson: "El verdadero muro no se prueba en los partidos fáciles. Se prueba cuando todo el mundo espera que caigas. Y ahí, cuando el cemento cruje y los ladrillos tiemblan, es cuando demuestras de qué estás hecha.",
    year: "2022",
    location: "Turín, Italia"
  },
  {
    id: 7,
    number: "Capítulo 7",
    title: "Mantener el muro cuando ya no hace falta",
    subtitle: "El verdadero nivel",
    summary: "Lyon, 2026. Tiane tiene 34 años y sigue llegando una hora antes. Dos Champions, cinco ligas francesas. Podría descansar. Pero no. 'El día que deje de matarme, alguien más me va a pasar. Y yo no vine hasta acá para que me pasen'. Enseña a las jóvenes. Sigue mejorando. El muro nunca deja de crecer.",
    lesson: "El éxito no se mide en copas levantadas. Se mide en los días después de levantarlas. Porque cualquiera puede llegar a la cima. El grande es el que decide quedarse ahí.",
    year: "2026",
    location: "Lyon, Francia"
  },
  {
    id: 8,
    number: "Capítulo 8",
    title: "Los 10 ladrillos del Muro Endler",
    subtitle: "El manual para que tú también lo construyas",
    summary: "Los diez principios que construyeron el muro de Christiane: Cimientos de humildad, ladrillos diarios de trabajo, cemento del silencio, refuerzo de resiliencia, altura estratégica, muro colectivo, impermeabilización emocional, reconstrucción constante, puerta blindada para los sueños, y vista desde arriba. No son frases bonitas. Son principios vividos en carne propia.",
    lesson: "Estos diez ladrillos no son de Tiane. Son tuyos. Toma uno hoy. Solo uno. Pónlo. Mañana otro. Y dentro de un año vas a mirar atrás y vas a decir: 'Yo también tengo mi muro'.",
    year: "2026",
    location: "Algarrobo, Chile"
  }
];

export const timeline = [
  {
    year: 2006,
    title: "El Cambio",
    description: "Marco Antonio Cornez la descubre y le dice: 'Vas a ser la mejor arquera de Chile'. Tiane deja de ser delantera y se convierte en portera.",
    location: "Santiago, Chile",
    club: "Santiago Oriente / Selección Sub-17"
  },
  {
    year: 2008,
    title: "Debut Profesional",
    description: "Debuta en Primera División con Everton de Viña del Mar. Dos penales parados en su primer partido.",
    location: "Viña del Mar, Chile",
    club: "Everton"
  },
  {
    year: 2011,
    title: "Llega a Colo-Colo",
    description: "El club más grande de Chile la ficha. A los 20 años la nombran capitana. Comienza la profesionalización del fútbol femenino chileno.",
    location: "Santiago, Chile",
    club: "Colo-Colo"
  },
  {
    year: 2012,
    title: "Campeona de América",
    description: "Capitana de Colo-Colo en la Copa Libertadores. Paró penales decisivos en la final. Primera gran conquista internacional.",
    location: "Brasil",
    club: "Colo-Colo",
    trophy: "Copa Libertadores Femenina"
  },
  {
    year: "2013-2014",
    title: "Universidad en Estados Unidos",
    description: "Estudia y juega en la University of South Florida (USF). Combina su carrera deportiva con estudios universitarios. Experiencia fundamental en su desarrollo.",
    location: "Tampa, Florida, USA",
    club: "USF Bulls"
  },
  {
    year: 2015,
    title: "Chelsea FC",
    description: "Firma con el Chelsea de la WSL inglesa. Primera experiencia en el fútbol europeo de élite. Aprende del más alto nivel.",
    location: "Londres, Inglaterra",
    club: "Chelsea FC Women"
  },
  {
    year: 2015,
    title: "La Lesión",
    description: "Rotura de menisco en la Copa América mientras jugaba para Chelsea. Pensó en retirarse. Volvió más fuerte seis meses después.",
    location: "Chile",
    club: "Selección de Chile / Chelsea FC"
  },
  {
    year: 2016,
    title: "Salto a España",
    description: "Ficha por el Valencia CF. Primera chilena en la Liga Iberdrola. El muro cruza el océano definitivamente.",
    location: "Valencia, España",
    club: "Valencia CF"
  },
  {
    year: 2017,
    title: "París Saint-Germain",
    description: "Llega al PSG. Cuatro años ganando ligas y copas. Se consolida como una de las mejores del mundo.",
    location: "París, Francia",
    club: "Paris Saint-Germain"
  },
  {
    year: 2019,
    title: "Mundial de Francia",
    description: "Capitana de Chile en su primer Mundial Femenino. Atajadas históricas contra Estados Unidos. El mundo conoce a Tiane.",
    location: "Francia",
    club: "Selección de Chile",
    trophy: "Mundial FIFA - Participación histórica"
  },
  {
    year: 2021,
    title: "Lyon y Tokio 2021",
    description: "Ficha por el Olympique de Lyon, el club más ganador de Europa. Capitana de Chile en los Juegos Olímpicos de Tokio, primera participación olímpica de La Roja.",
    location: "Lyon, Francia / Tokio, Japón",
    club: "Olympique Lyonnais / Selección de Chile",
    trophy: "Juegos Olímpicos - Participación histórica"
  },
  {
    year: 2022,
    title: "Campeona de Europa y The Best FIFA",
    description: "Final de Champions League. Lyon 3-1 Barcelona. MVP del partido. Primera chilena en ganar la orejona. Dedicado a Marco Cornez. Ganadora del The Best FIFA a la mejor portera del mundo.",
    location: "Turín, Italia / Mundial",
    club: "Olympique Lyonnais",
    trophy: "UEFA Champions League + The Best FIFA"
  },
  {
    year: 2024,
    title: "París 2024",
    description: "Capitana en los Juegos Olímpicos de París. Paró penal a Trinity Rodman contra Estados Unidos.",
    location: "París, Francia",
    club: "Selección de Chile",
    trophy: "Juegos Olímpicos - Participación"
  },
  {
    year: 2026,
    title: "El Muro Sigue en Pie",
    description: "A los 34 años, sigue siendo titular indiscutida en Lyon y capitana de Chile. Contrato hasta 2027. El muro nunca deja de crecer.",
    location: "Lyon, Francia",
    club: "Olympique Lyonnais"
  }
];

export const achievements = [
  {
    id: 1,
    title: "Copa Libertadores Femenina",
    year: 2012,
    location: "Brasil",
    coordinates: { lat: -15.7939, lng: -47.8828 },
    description: "Campeona con Colo-Colo. Paró penales decisivos en la final.",
    type: "club",
    icon: "trophy"
  },
  {
    id: 2,
    title: "Mundial FIFA Femenino",
    year: 2019,
    location: "Francia",
    coordinates: { lat: 46.2276, lng: 2.2137 },
    description: "Capitana de Chile en su primer Mundial. Atajadas históricas contra Estados Unidos.",
    type: "national",
    icon: "globe"
  },
  {
    id: 3,
    title: "UEFA Champions League",
    year: 2022,
    location: "Turín, Italia",
    coordinates: { lat: 45.0703, lng: 7.6869 },
    description: "Campeona con Lyon. MVP de la final. Primera chilena en ganar la Champions.",
    type: "club",
    icon: "star"
  },
  {
    id: 4,
    title: "Juegos Olímpicos Tokio 2021",
    year: 2021,
    location: "Tokio, Japón",
    coordinates: { lat: 35.6762, lng: 139.6503 },
    description: "Capitana de Chile en su primera y única participación olímpica. Hito histórico para el fútbol femenino chileno.",
    type: "national",
    icon: "medal"
  },
  {
    id: 5,
    title: "5x Campeona de Francia",
    year: "2019-2024",
    location: "Francia",
    coordinates: { lat: 45.7640, lng: 4.8357 },
    description: "Cinco ligas francesas consecutivas con PSG y Lyon.",
    type: "club",
    icon: "trophy"
  },
  {
    id: 6,
    title: "Copa América - Mejor Arquera",
    year: 2023,
    location: "Ecuador",
    coordinates: { lat: -1.8312, lng: -78.1834 },
    description: "Elegida mejor portera del torneo. Chile subcampeón.",
    type: "national",
    icon: "award"
  },
  {
    id: 7,
    title: "The Best FIFA - Ganadora y Nominaciones",
    year: "2022 (Ganadora)",
    location: "Mundial",
    coordinates: { lat: 20, lng: 0 },
    description: "Ganadora The Best FIFA 2022 a la mejor portera del mundo. 5 nominaciones totales (2019-2024). 3 veces en el 11 ideal FIFA/FIFPro.",
    type: "individual",
    icon: "star"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Nicolás Endler",
    role: "Hermano",
    quote: "La Tiane fue la única que me pescó con el fútbol. Era valiente para ser tan chica. Jugaba con hombres en la empresa de mi papá. Siempre fue así. Sin miedo.",
    image: null
  },
  {
    id: 2,
    name: "Marco Antonio Cornez",
    role: "Descubridor (†2022)",
    quote: "Con esa altura y esos reflejos... vas a ser la mejor arquera de Chile. El arco no es un castigo. Es tu lugar. Ahí nadie te pasa.",
    image: null
  },
  {
    id: 3,
    name: "Jill Ellis",
    role: "Ex DT Selección USA",
    quote: "Endler fue espectacular contra nosotros en el Mundial. Es una de las mejores atajadoras que he visto en mi carrera.",
    image: null
  },
  {
    id: 4,
    name: "Sonia Bompastor",
    role: "Ex DT Lyon",
    quote: "Tiane es un ejemplo para todas. A su edad sigue siendo la mejor porque nunca se conforma. Llega primera y se va última.",
    image: null
  }
];

export const ladrillos = [
  {
    id: 1,
    title: "Cimientos de humildad",
    subtitle: "Nunca creas que ya llegaste",
    description: "La humildad no es bajarse el ego. Es nunca subirlo. Tiane a los 34 años sigue diciendo: 'Siempre se puede mejorar más'."
  },
  {
    id: 2,
    title: "Ladrillos diarios de trabajo",
    subtitle: "La disciplina que nadie ve",
    description: "El muro no se levanta en un día. Se levanta todos los días. Tiane entrena a las 6:30 aunque no haya partido."
  },
  {
    id: 3,
    title: "Cemento del silencio",
    subtitle: "Liderazgo que no necesita volumen",
    description: "El verdadero liderazgo no es el que más se oye. Es el que más se siente. Tiane lidera con ejemplo, no con gritos."
  },
  {
    id: 4,
    title: "Refuerzo de resiliencia",
    subtitle: "Cada golpe es material de construcción",
    description: "Las grietas no son debilidad. Son los lugares por donde entra el cemento nuevo. La lesión 2015 casi la mata. Volvió más fuerte."
  },
  {
    id: 5,
    title: "Altura estratégica",
    subtitle: "Usa lo que otros ven como desventaja",
    description: "La altura física la tenía desde los 15. La altura mental la construyó con ladrillos de disciplina que nadie ve."
  },
  {
    id: 6,
    title: "Muro colectivo",
    subtitle: "Tu defensa es más fuerte cuando proteges a las de al lado",
    description: "Tu éxito es colectivo. Tiane nunca dice 'yo gané'. Dice 'ganamos'. Profesionalizó el fútbol para las que vienen detrás."
  },
  {
    id: 7,
    title: "Impermeabilización emocional",
    subtitle: "Las críticas resbalan. El foco se mantiene",
    description: "Las críticas son como la lluvia. Si tienes buen techo, solo te mojas por fuera. Tiane tiene claro su 'porqué'."
  },
  {
    id: 8,
    title: "Reconstrucción constante",
    subtitle: "El muro que no se revisa, se cae",
    description: "Cada pretemporada, Tiane revisa su juego. Videos de errores. Cambios en dieta y fuerza. A los 34 sigue mejorando."
  },
  {
    id: 9,
    title: "Puerta blindada para los sueños",
    subtitle: "Deja entrar solo lo que te hace más fuerte",
    description: "El arco tiene una puerta. Tiane decide quién entra: familia, fe, trabajo. Lo demás queda afuera."
  },
  {
    id: 10,
    title: "Vista desde arriba",
    subtitle: "Cuando el muro está terminado, lo único que ves es horizonte",
    description: "El muro no es para encerrarte. Es para darte la altura para ver más lejos. Tiane sigue jugando hasta los 38."
  }
];

// Mock cart state
export const cartInitialState = {
  items: [],
  total: 0
};

// Mock order
export const createMockOrder = (formData) => {
  return {
    orderId: `ORD-${Date.now()}-${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
    date: new Date().toISOString(),
    customer: formData,
    items: [
      {
        id: 1,
        name: bookInfo.title,
        quantity: formData.quantity || 1,
        price: bookInfo.price,
        image: bookInfo.coverImage
      }
    ],
    subtotal: bookInfo.price * (formData.quantity || 1),
    shipping: formData.shipping === 'express' ? 5990 : 2990,
    total: (bookInfo.price * (formData.quantity || 1)) + (formData.shipping === 'express' ? 5990 : 2990),
    status: 'pending',
    paymentMethod: formData.paymentMethod || 'credit-card',
    shippingMethod: formData.shipping || 'standard'
  };
};
